import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type ValidateAttestModel = {
  id: string | number
}

export const fetchValidateAttest = ({ id }: ValidateAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/modal/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveValidateAttest = ({ id }: ValidateAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/modal/save/${id}`,
    makeAxiosHttpClient()
  )
}
